const isAuthenticated = () => {
  if (
    localStorage.getItem("auth_token") &&
    localStorage.getItem("auth_username") &&
    localStorage.getItem("auth_userid") &&
    localStorage.getItem("auth_superuser")
  ) {
    const token = localStorage.getItem("auth_token");

    if (token.length == 40) {
      return true;
    }
  }
  return false;
};

export default isAuthenticated;



// WEBPACK FOOTER //
// ./src/services/auth.js